export { ColorName, Color } from "@daytrip/legacy-enums";
export type { ColorNameKeys } from "@daytrip/legacy-enums";
